import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { formatMoney } from '../../../../util/currency';

import css from '../../OrderItemInfo.css';

const EveningDiscount = ({ discount, intl }) => {
  if (!discount || !discount.lineTotal.amount) return null;
  const { lineTotal, code } = discount;

  return (
    <p className={classNames(css.text, css.priceContainer)} key={code}>
        <span className={css.productName}>
          <FormattedMessage id="OrderInfo.eveningDiscountText" />
        </span>
      <span className={css.text}>{formatMoney(intl, lineTotal)}</span>
    </p>
  );
}

export default EveningDiscount;
